import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const keys = 'user'
const state = {
    operationallayers: [],//图层
    basemaps: [],// 底图
    activeIndex: -1, //当前激活的tab导航
    widgetsAtStart: {}, //tab导航数据
    user: null,//用户信息
    childToken: null//子公司token
}
const getters = {
    getUser: () => {
        if (!state.user) {
            state.user = JSON.parse(localStorage.getItem(keys));
        }
        return state.user
    },
    getChildUser: () => {
        return state.childToken || JSON.parse(localStorage.getItem('childToken') || 'null')
    }
}
const mutations = {
    //更新当前激活的tab索引
    updateaAtiveIndex (state, newVal) {
        state.activeIndex = newVal
    },
    updateBasemaps (state, newVal) {
        state.basemaps = newVal
    },
    updateWidgetsAtStart (state, newVal) {
        state.widgetsAtStart = newVal
    },
    updateOperationallayers (state, newVal) {
        state.operationallayers = newVal
    },
    $_setStorage (state, value) {
        state.user = value
        localStorage.setItem(keys, JSON.stringify(value))
    },
    $_removeStorage (state) {
        state.user = null
        localStorage.removeItem(keys)
    },
    $_setChildStorage (state, value) {
        state.childToken = value
        localStorage.setItem("childToken", JSON.stringify(value))
    },
    $_removeChildStorage (state) {
        state.childToken = null
        localStorage.removeItem("childToken")
    },
}
const actions = {

}
export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})



// WEBPACK FOOTER //
// ./src/store.js